import { useEffect } from 'react';
import Header from '@/components/Header';
import ImageCarouselHero from '@/components/ImageCarouselHero';
import CuratedInsightsSection from '@/components/CuratedInsightsSection';
import ServicesSection from '@/components/ServicesSection';
import AboutSection from '@/components/AboutSection';
import ExpertiseSection from '@/components/ExpertiseSection';
// import PlatinumSection from '@/components/PlatinumSection';
import WhyChooseUsSection from '@/components/WhyChooseUsSection';
import FooterSection from '@/components/FooterSection';
import CosmicBackground from '@/components/CosmicBackground';
import useSEO from '@/hooks/useSEO';
import { injectStructuredData, getDocketLabsOrganizationSchema, getDocketLabsWebsiteSchema } from '@/utils/structuredData';

const Index = () => {
  // Enhanced SEO implementation
  useSEO({
    title: 'DocketLabs | Transforming Legal Workflows with AI Excellence',
    description: 'Transform your legal practice with AI consulting from DocketLabs. Proven strategies, expert training & custom solutions. Get your free consultation today.',
    ogTitle: 'DocketLabs - AI Legal Consulting & Strategy for Law Firms',
    ogDescription: 'Transform your legal practice with AI consulting from DocketLabs. Proven strategies, expert training & custom solutions for law firms.',
    ogImage: '/lovable-uploads/Docket_Labs_logo-blue-black.png',
    ogUrl: 'https://docketlabs.com',
    canonical: 'https://docketlabs.com',
    twitterTitle: 'DocketLabs - AI Legal Consulting & Strategy',
    twitterDescription: 'Transform your legal practice with AI consulting from DocketLabs. Proven strategies, expert training & custom solutions.',
  });

  useEffect(() => {
    // Inject structured data for better SEO
    injectStructuredData(getDocketLabsOrganizationSchema());
    injectStructuredData(getDocketLabsWebsiteSchema());
    
    // Initialize Intersection Observer for animations
    const initAnimations = () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('appear');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      
      document.querySelectorAll('.animate-fade-in, .animate-scale-in, .animate-slide-in-right, .animate-slide-in-left').forEach((element) => {
        observer.observe(element);
      });
    };
    
    // Handle scroll restoration
    history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    
    // Initialize animations when DOM is fully loaded
    window.addEventListener('load', initAnimations);
    return () => window.removeEventListener('load', initAnimations);
  }, []);
  
  return (
    <>
      <Header />
      <main className="bg-background text-foreground overflow-hidden relative">
        {/* Hero section without the cosmic background effect */}
        <ImageCarouselHero />
        
        {/* Apply cosmic background only to content below the hero */}
        <div className="relative">
          <CosmicBackground />
          <CuratedInsightsSection />
          <ServicesSection />
          <AboutSection />
          <ExpertiseSection />
          {/* PlatinumSection hidden temporarily */}
          {/* <PlatinumSection /> */}
          <WhyChooseUsSection />
          <FooterSection />
        </div>
      </main>
    </>
  );
};

export default Index;
